import React, { useState } from 'react'
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { fileDownload } from '../../helpers/helpers';
import SafeBtn from './SafeBtn';

const DownloadBtn = ({
  id,
  text,
  tipText,
  url,
  className,
  width,
  loginIdToken,
  icon,
  disabled,
}) => {
  const [ loading, setLoading ] = useState(false);
  const stopLoading = () => setLoading(false);

  return (
    <>
      <SafeBtn
        loading={loading}
        id={id}
        className={className}
        style={{
          width,
          fontSize: '14px'
        }}
        disabled={!url || disabled}
        onClick={() => {
          setLoading(true);
          fileDownload(url, loginIdToken, stopLoading);
        }}
      >
        <FontAwesomeIcon icon={icon || faDownload} />
        &nbsp;&nbsp;
        {text}
      </SafeBtn>
      {tipText && (
        <UncontrolledTooltip target={id}>
          {tipText}
        </UncontrolledTooltip>
      )}
    </>
  )
};

DownloadBtn.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  tipText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.string,
  loginIdToken: PropTypes.string.isRequired,
  icon: PropTypes.objectOf(PropTypes.any),
  disabled: PropTypes.bool,
};

DownloadBtn.defaultProps = {
  className: 'btn-orsan-primary',
  width: '170px',
  icon: null,
  disabled: false,
};

const mapStateToProps = state => ({
  loginIdToken: state.login.id_token,
});

export default connect(mapStateToProps)(DownloadBtn);
